import { CsvImport as CsvImportComponent } from '../../components/Widgets/CsvImport'
import { GenericWrapper } from './styles'

export function CsvImport(): React.ReactNode {
  return (
    <GenericWrapper>
      <CsvImportComponent />
    </GenericWrapper>
  )
}
